import React from "react";

const WhyUs = (props) => {
    const data = [
        {
            title: "Friendly environment",
            description:
                "Feel the flavour, feel the aroma, feel the taste in every dish.",
        },
        {
            title: "Fresh food",
            description:
                "Our motto is to make the atmosphere friendly and as efficient as possible. The waiters are patiently and happily take your order and serve the meal in the estimated time. A nice and lovely environment forces you to come back for another date.",
        },
        {
            title: "Fresh food",
            description:
                "In a food restaurant, food plating is a central idea to keep guests happy as they experience your restaurant. People scan the taste before eating, so our creative plating can enhance both the appearance and the flavor of the food.",
        },
    ];

    return (
        <section id="why-us" className="why-us">
            <div className="container">
                <div className="section-title">
                    <h1 className="display-5">
                        Why choose <span className="text-warning">Our Restaurant</span>
                    </h1>
                    <p className="medium">
                        Feel the flavour, feel the aroma, feel the taste in every dish.
                    </p>
                </div>

                <div className="row">
                    {data?.map((_data, index) => (
                        <div className="col-lg-4">
                            <div className="box">
                                <span>0{index + 1}</span>
                                <h4>{_data.title}</h4>
                                <p>{_data.description}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default WhyUs;
